import { useDispatch, useSelector } from 'react-redux'

import { actionTypes } from 'actions/actionTypes'
import { applyPromoCode } from 'actions/home'
import { redirect } from 'actions/redirect'
import { trackUTMAndPromoCode } from 'actions/tracking'
import { clickClaimDiscountBar } from 'actions/trackingKeys'
import { useIsSignupMotivationsEnabled } from 'hooks/useIsSignupMotivationsEnabled'
import { signupMotivationsSlug, boxPriceSlug } from 'routes/Signup/signupConfig'
import { getIsAuthenticated } from 'selectors/auth'
import { createGetErrorForActionType } from 'selectors/status'

export const useGetPromoBannerDispatchedActions = () => {
  const dispatch = useDispatch()
  const dispatchApplyPromoCode = () => dispatch(applyPromoCode())
  const isSignupMotivationsEnabled = useIsSignupMotivationsEnabled()
  const signupURL = isSignupMotivationsEnabled
    ? `/signup/${signupMotivationsSlug}`
    : `/signup/${boxPriceSlug}`
  const dispatchRedirect = () => dispatch(redirect(signupURL))
  const dispatchTrackUTMAndPromoCode = (trackingEventName: string = clickClaimDiscountBar) =>
    dispatch(trackUTMAndPromoCode(trackingEventName))

  return {
    dispatchApplyPromoCode,
    dispatchRedirect,
    dispatchTrackUTMAndPromoCode,
  }
}

export const useCanShowPromoBanner = () => {
  const isAuthenticated = useSelector(getIsAuthenticated)
  const promoCodeGetError = useSelector(createGetErrorForActionType(actionTypes.PROMO_GET))
  const promoCodeApplyError = useSelector(createGetErrorForActionType(actionTypes.PROMO_APPLY))

  const hasError = !!promoCodeGetError || !!promoCodeApplyError

  const hide = isAuthenticated || hasError

  return !hide
}
